import React from 'react';
import Header from "../Header/Header";
import {SkeletonBrick} from "@consta/uikit/Skeleton";
import {Footer} from "../Footer";

export const Skeleton = () => {
    return (
        <>
            <Header />
            <div className='skeleton'>
                <SkeletonBrick height={150} />
                <SkeletonBrick height={150} />
                <SkeletonBrick height={150} />
            </div>
            <Footer />
        </>
    );
};
